export const visit = (vm, at) => {
at({ "fr": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} sur {{totalBytes}}" }, "fileSizeLimit": "Le fichier ne peut pas d\xE9passer\xA0{{size}}" } } });
};